var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgViewtech(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "23px",
    height: "20px",
    viewBox: "0 0 23 20",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "view") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "view",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.81866,1 C17.21076,1 21.69676,4.87976 22.63726,10 C21.69676,15.1202 17.21076,19 11.81866,19 C6.42648,19 1.94051,15.1202 1,10 C1.94051,4.87976 6.42648,1 11.81866,1 Z M11.81866,17 C16.05426,17 19.67866,14.052 20.59606,10 C19.67866,5.94803 16.05426,3 11.81866,3 C7.58296,3 3.95858,5.94803 3.04114,10 C3.95858,14.052 7.58296,17 11.81866,17 Z M11.81866,14.5 C9.33334,14.5 7.31862,12.4853 7.31862,10 C7.31862,7.51472 9.33334,5.5 11.81866,5.5 C14.30386,5.5 16.31866,7.51472 16.31866,10 C16.31866,12.4853 14.30386,14.5 11.81866,14.5 Z M11.81866,12.5 C13.19936,12.5 14.31866,11.3807 14.31866,10 C14.31866,8.6193 13.19936,7.5 11.81866,7.5 C10.43796,7.5 9.31862,8.6193 9.31862,10 C9.31862,11.3807 10.43796,12.5 11.81866,12.5 Z",
    id: "Shape",
    fill: "#000000",
    fillRule: "nonzero"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgViewtech);
export default __webpack_public_path__ + "static/media/viewtech.b9b674b09ad44d56f4b47f2e1b3e3380.svg";
export { ForwardRef as ReactComponent };